var map = {
	"./Dots.svg": 11464,
	"./Illustration-Error.svg": 97363,
	"./MicPermissionsDialogImage.svg": 81246,
	"./PlayIcon.svg": 8649,
	"./addhero.16.svg": 21716,
	"./fonts/Bahnschrift.woff": 28317,
	"./icon-16.png": 42938,
	"./icon-32.png": 13492,
	"./icon-80.png": 50783,
	"./logo-filled.png": 30661,
	"./ping_image.png": 4581,
	"./transcription_signal_indicator.png": 42850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34215;